import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import SwipeableViews from 'react-swipeable-views';
import { bindKeyboard } from 'react-swipeable-views-utils';
import moment from 'moment';
import { callbackify } from 'util';

const BindKeyboardSwipeableViews = bindKeyboard(SwipeableViews);

class Redeem extends Component {
  constructor(props) {
    super(props);

    let storageState = {};
    if(localStorage.verificationPIN && localStorage.verificationPIN !== 'undefined') {
      storageState.verificationPIN = localStorage.verificationPIN;
    }
    if (localStorage.nonWinner && localStorage.nonWinner !== 'undefined') {
      storageState.nonWinner = localStorage.nonWinner;
    }
    if (localStorage.redemptionHeader && localStorage.redemptionHeader !== 'undefined') {
      storageState.redemptionHeader = localStorage.redemptionHeader;
    }
    if (localStorage.redemptionColor && localStorage.redemptionColor !== 'undefined') {
      storageState.redemptionColor = localStorage.redemptionColor;
    }
    if (localStorage.fontTopPadding && localStorage.fontTopPadding !== 'undefined') {
      storageState.fontTopPadding = localStorage.fontTopPadding;
    }
    if (localStorage.fontBottomPadding && localStorage.fontBottomPadding !== 'undefined') {
      storageState.fontBottomPadding = localStorage.fontBottomPadding;
    }
    if (localStorage.fontLeftPadding && localStorage.fontLeftPadding !== 'undefined') {
      storageState.fontLeftPadding = localStorage.fontLeftPadding;
    }
    if (localStorage.fontRightPadding && localStorage.fontRightPadding !== 'undefined') {
      storageState.fontRightPadding = localStorage.fontRightPadding;
    }
    if (localStorage.fontColor && localStorage.fontColor !== 'undefined') {
      storageState.fontColor = localStorage.fontColor;
    }
    if(localStorage.maxAgeCopy && localStorage.maxAgeCopy !== 'undefined') {
      storageState.maxAgeCopy = localStorage.maxAgeCopy;
    }

    this.state = {
      index: 0,
      date: null,
      code: ['','','',''],
      codeCompleted: false,
      verificationPIN: null,
      nonWinner: false,
      redemptionHeader: null,
      redemptionColor: null,
      fontTopPadding: null,
      fontBottomPadding: null,
      fontLeftPadding: null,
      fontRightPadding: null,
      fontColor: null,
      initialHeight: 0,
      keyboardActive: false,
      maxAgeCopy: false,
      ...storageState
    }

    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
  }

  handleWindowResize() {
    this.setState({keyboardActive: window.innerHeight < this.state.initialHeight});
  }

  handleChangeIndex(index) {
    browserHistory.push('/thanks');
  }

  validateCode(code) {
    let codeCompleted = true
    let compiledCode = ''
    for (let k = 0; k < code.length; k++) {
      compiledCode = compiledCode.concat(code[k])
      if (!code[k]) {
        codeCompleted = false
      }
    }
    if (codeCompleted) {
      let pin = this.state.verificationPIN
      if (pin === compiledCode) {
        this.setState({codeCompleted: true})
      }
    } else {
      this.setState({codeCompleted: false})
    }
  }

  setValue(index, val = '') {
    let changed = []
    const code = this.state.code
    for (let k = 0; k < code.length; k++) {
      changed.push(code[k])
    }
    changed[index] = val
    this.setState({code: changed})
    this.validateCode(changed)
  }

  clearValue(event) {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    this.setValue(index)
  }

  changeCode(event) {
    if (event.target.value) {
      const code = this.state.code
      const form = event.target.form;

      for (let i = 0; i < code.length; i++) {
        if (!code[i]) {
          this.setValue(i, event.target.value)
          if (i + 1 < code.length) {
            form.elements[i + 1].focus();
          } else {
            form.elements[i].blur();
          }
          break
        }
      }
    }
  }

  setTime() {
    const date = new Date();
    this.setState({
      date: date
    });
  }

  componentWillMount() {
    this.setTime();
  }

  componentDidMount() {
    this.timmerID = window.setInterval(function () {
      this.setTime();
    }.bind(this), 1000);

    this.setState({initialHeight: window.innerHeight});
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.clearInterval(this.timmerID);
  }

  render() {
    const nonWinner = this.state.nonWinner == "true" ? true : false
    const pinSent = sessionStorage.pinSent == 'true' ? true : false
    const redemptionColor = this.state.redemptionColor;
    const redemptionHeader = this.state.redemptionHeader;
    const fontColor = this.state.fontColor;
    const maxAgeCopy = this.state.maxAgeCopy == "true" ? true : false

    const fontTopPadding = 0 + Number(this.state.fontTopPadding);
    const fontBottomPadding = 0 + Number(this.state.fontBottomPadding);
    const fontLeftPadding = 0 + Number(this.state.fontLeftPadding);
    const fontRightPadding = 0 + Number(this.state.fontRightPadding);

    return (
      <div className="genericAppInner">
        <div className="page">
          <div className="verticalWrap contentWrap">
            <div className="genericInnerWrap">
              <img className="redepmtionHeader" src={redemptionHeader} />
              <h3
                className="timeStamp"
                style={{
                  padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                }}
              >
                {moment(this.state.date).format('l LTS')}
              </h3>

              <form id="codeBox" className="topSpace bottomSpace">
                <input type="number" maxLength="1" className={nonWinner ? "codeField nonWinner" : "codeField winner"} style={{borderColor: redemptionColor, color: fontColor, padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'}} name="chars[1]" value={this.state.code[0]} onClick={this.clearValue.bind(this)} onChange={this.changeCode.bind(this)} />
                <input type="number" maxLength="1" className={nonWinner ? "codeField nonWinner" : "codeField winner"} style={{borderColor: redemptionColor, color: fontColor, padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'}} name="chars[2]" value={this.state.code[1]} onClick={this.clearValue.bind(this)} onChange={this.changeCode.bind(this)} />
                <input type="number" maxLength="1" className={nonWinner ? "codeField nonWinner" : "codeField winner"} style={{borderColor: redemptionColor, color: fontColor, padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'}} name="chars[3]" value={this.state.code[2]} onClick={this.clearValue.bind(this)} onChange={this.changeCode.bind(this)} />
                <input type="number" maxLength="1" className={nonWinner ? "codeField nonWinner" : "codeField winner"} style={{borderColor: redemptionColor, color: fontColor, padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'}} name="chars[4]" value={this.state.code[3]} onClick={this.clearValue.bind(this)} onChange={this.changeCode.bind(this)} />
              </form>

              <h3
                className="topSpace"
                style={{
                  padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                }}
              >
                ENTER THE CODE PROVIDED IN THE BOXES ABOVE
              </h3>

              <div className={this.state.keyboardActive ? "redemptionKeyboard" : "redemption"}>
                <p
                  className="helpText"
                >
                  Slide to redeem
                </p>
                {maxAgeCopy &&
                  <p
                    className="ageWarning"
                    style={{
                      padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                    }}
                  >
                    *must be 18 years of age
                  </p>
                }

                {!this.state.codeCompleted &&
                  <div className={nonWinner ? "nonWinnerButtonSlideWrap" : "winnerButtonSlideWrap"}>
                    <div id="unSlid" className="buttonSlide">
                      <span className="iconWrap"><span className="icon-chevron-right"></span></span>
                      <span className="redeem" style={{padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'}}>REDEEM</span>
                    </div>
                  </div>
                }
                {this.state.codeCompleted &&
                  <BindKeyboardSwipeableViews className={nonWinner ? "nonWinnerButtonSlideWrap" : "winnerButtonSlideWrap"}
                    style={{borderColor: redemptionColor}}
                    axis="x-reverse" hysteresis={0.9}
                    onChangeIndex={this.handleChangeIndex}
                    resistance>
                    <div id="unSlid" className="buttonSlide">
                      <span className="iconWrap" style={{backgroundColor: redemptionColor}}><span className="icon-chevron-right"></span></span>
                      <span className="redeem"style={{color: redemptionColor}}>REDEEM</span>
                    </div>
                    <div id="slid" className="buttonSlide" style={{backgroundColor: redemptionColor}}>
                    </div>
                  </BindKeyboardSwipeableViews>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Redeem;



// WEBPACK FOOTER //
// ./src/components/Redeem.js